<template>
  <div id="select_modification">
    <loader v-if="loader"/>
    <Notificator :messages="messages"/>
    <FilterSelected :filter-selected="filterSelected" @deleteBlock="deleteBlock"/>
    <FilterTabs :filters-data="filtersData" @pushFromTempToSelected="pushFromTempToSelected"/>
    <ModalDeal :filter="filterSelected" :products="products" :links="links" :user-hash="userHash"/>
    <div class="controll-container">
      <div v-if="products" class="products-count">
        <p>
          <b>
            Найдено: {{ products.length }}
          </b>
        </p>
      </div>
      <div class="buttons">
        <span v-if="filterSelected.length" class="mail secondary" style="cursor: pointer" @click="getDeal()">

          <svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 128 90" style="enable-background:new 0 0 128 90; height: 18px; fill: #008f86;" xml:space="preserve">
            <path d="M116.7,12.8c-1-1.3-2.9-1.6-4.2-0.6c0,0,0,0,0,0L64.1,48.3c-0.4,0.3-0.8,0.3-1.2,0L15.5,12.1c-1.3-1-3.2-0.8-4.2,0.6
             s-0.8,3.2,0.6,4.2l37.3,28.5L12.3,73.2c-1.3,1-1.6,2.9-0.6,4.2s2.9,1.6,4.2,0.6l0,0l38.2-28.9l5.2,4c2.5,1.9,5.9,1.9,8.4,0.1
             l5.4-4.1L111.8,78c1.3,1,3.2,0.7,4.2-0.6s0.7-3.2-0.6-4.2l0,0L78.2,45.3l38-28.3C117.4,16,117.7,14.2,116.7,12.8z"/>
            <path d="M113,0H15C6.7,0,0,6.7,0,15v60c0,8.3,6.7,15,15,15l0,0h98c8.3,0,15-6.7,15-15l0,0V15C128,6.7,121.3,0,113,0z M122,75
             c0,5-4,9-9,9H15c-5,0-9-4-9-9V15c0-5,4-9,9-9h98c5,0,9,4,9,9V75z"/>
          </svg>
        </span>
        <PdfGenerator v-if="filterSelected.length" :preview_logo="preview_logo" :form="form" :links="links" :filter-html="filterHtml" :products="products" />
        <a @click="clearFilter()" class="product-card__button">Очистить фильтр</a>
        <a @click="getTableData()" class="product-card__button" title="Показать результат">Показать результат</a>
      </div>
    </div>

    <TableData :products="products" :links="links"/>

  </div>
</template>

<script>

import goals from '../goals'
import axios from 'axios'
import FilterTabs from './components/FilterTabs'
import FilterSelected from './components/FilterSelected'
import Notificator from "./components/Notificator";
import TableData from "./components/TableData";
import Loader from "./components/Loader";
import ModalDeal from "./components/ModalDeal";
import MicroModal from "micromodal";
import PdfGenerator from "./components/PdfGenerator";

// const api_url = 'https://system-selection.herokuapp.com'
const api_url = 'https://products-list.owen.ru'

export default {
  name: 'select_modification',
  computed: {
    filterHtml: function(){
      return document.querySelector('.group_tab-container')
    }
  },
  data()
  {
    return {
      filtersData: {},
      filterSelected: [],
      messages: [],
      loader: false,
      products: null,
      links: null,
      filtersDataUpdated: {},
      userHash: null,

      preview_logo: null,
      form: {
        companyName: null,
        adress: null,
        phones: [''],
        emails: [{
          email: null,
          main: true,
          department: null,
        }],
        webSiteUrl: null,
      }


    }
  },
  components: {
    PdfGenerator,
    ModalDeal,
    Loader,
    TableData,
    Notificator,
    FilterTabs,
    FilterSelected,
  },
  methods: {
    getXlsx()
    {
      axios.post(process.env.NODE_ENV === 'production' ? '/upl_files/modules/select_backend/mailer/index.php' : '/api/index.php', {
        getXlsx: true,
        products : this.products,
        filter: this.filterSelected,
      })
        .then( response => {
          let link = document.createElement("a")
          link.setAttribute("href", process.env.NODE_ENV === 'production' ? '/upl_files/modules/select_backend/mailer/files/' : 'http://localhost:8081/files/' + response.data.fileName)
          link.setAttribute("download", response.data.fileName+"")
          // link.click()
        })
    },
    cheeckLimit(data)
    {

      if ((parseInt(data.count) + parseInt(this.filtersData[data.root_index].summ)) > parseInt(this.filtersData[data.root_index].limits.max))
      {
        this.showMessage({
          type: "info",
          text: "Превышено максимальное значение: " + this.filtersData[data.root_index].limits.max,
        })
        return false
      }

      return true
    },
    getDeal()
    {
      MicroModal.show('modal-1')
    },
    clearFilter()
    {
      this.filterSelected = [];
      this.getTableData();
    },

    showMessage(message)
    {
      let id = Math.floor(Math.random() * 100000)
      message.id = id
      this.messages.push(message);
      setTimeout(() =>
      {
        let index = this.messages.filter((m, m_index) =>
        {
          if (m.id === id)
          {
            return m_index
          }
        })
        this.messages.splice(index, 1);
      }, 3500);
    },
    deleteBlock(tab_index)
    {
      const root_index = this.filterSelected[tab_index].root_index
      const summ = this.filtersData[root_index].summ - this.filterSelected[tab_index].count
      this.$set(this.filtersData[root_index], 'summ', summ)
      this.$delete(this.filterSelected, tab_index)
      this.getTableData()
    },
    pushFromTempToSelected(data)
    {
      if (!this.cheeckLimit(data))
      {
        return
      }
      this.filtersData[data.root_index].summ = parseInt(this.filtersData[data.root_index].summ) + parseInt(data.count)
      this.filterSelected.push(data)
    },
    getFilters()
    {
      let request = {
        query: 'filters',
        data: 'all',
      }
      axios.post(api_url, request).then((response) =>
      {
        response.data.forEach(i =>
        {
          this.$set(i, 'isActive', false)
          this.$set(i, 'count', 0)
          this.$set(i, 'summ', 0)
          this.$set(i, 'changed', false)
          i.child.forEach(ch =>
          {
            this.$set(ch, "changed", false);
            if (ch.limits)
            {
              this.$set(ch.limits, "minv", ch.limits.min)
              this.$set(ch.limits, "maxv", ch.limits.max)
            }
          })
        })
        this.filtersData = response.data

        for (var i = 0; i < this.filtersData.length; i++)
        {
          for (var a = 0; a < this.filtersData[i].child.length; a++)
          {
            for (var b = 0; b < this.filtersData[i].child[a].value.length; b++)
            {
              this.filtersData[i].child[a].value[b] = {
                name: this.filtersData[i].child[a].value[b],
                code: this.filtersData[i].child[a].value[b],
              };
            }
          }
        }
      })
    },
    downloadPDF(){

    },
    getTableData()
    {
      this.loader = true
      let request = {}
      if (this.filterSelected.length === 0)
      {
        request = {
          query: "table",
          data: "all",
        }
        axios.post(api_url, request).then(response =>
        {
          this.products = response.data.products || response.data
          this.clearFilterDisable()
          this.loader = false
        })
        return
      }
      let requestBody = []
      this.filterSelected.forEach(item =>
      {
        let tempItem = []
        if (item.child.length)
        {
          item.child.forEach(child =>
          {
            if (child.max)
            {
              tempItem.push({
                group: child.child_id,
                feature: {min: child.min, max: child.max},
                count: item.count,
              })
            } else
            {
              tempItem.push({
                group: child.child_id,
                feature: child.value.name,
                count: item.count,
              })
            }
          })
        } else
        {
          tempItem.push({
            group: item.root_id,
            count: item.count,
            feature: "total",
          })
        }
        requestBody.push(tempItem);
      })
      request = {
        query: "table",
        data: {
          request: requestBody,
        },
      }
      axios.post(api_url, request).then(response =>
      {
        if (response.data == "Wrong request!")
        {
          this.showMessage({
            type: "info",
            text: "Запрос содержит ошибку, попробуйте изменить фильтр",
          });
          return this.loader = false
        }
        if (response.data.message)
        {
          this.showMessage({
            type: "info",
            text: response.data.message,
          });
          return this.loader = false
        }
        this.filtersDataUpdated = response.data.filter
        this.products = response.data.products
        this.compareFilters()
      })
      goals.getTableData()
      this.loader = false
    },
    clearFilterDisable()
    {
      if (this.filtersDataUpdated && this.filtersDataUpdated.length > 1)
      {
        for (let i = 0; i < this.filtersData.length; i++)
        {
          for (let a = 0; a < this.filtersData[i].child.length; a++)
          {
            for (let b = 0; b < this.filtersData[i].child[a].value.length; b++)
            {
              this.filtersData[i].child[a].value[b].$isDisabled = false
            }
          }
        }
      }
    },
    compareFilters()
    {
      if (this.filtersDataUpdated && this.filtersDataUpdated.length > 1)
      {
        for (let i = 0; i < this.filtersData.length; i++)
        {
          for (let a = 0; a < this.filtersData[i].child.length; a++)
          {
            for (let b = 0; b < this.filtersData[i].child[a].value.length; b++)
            {
              this.filtersData[i].child[a].value[b].$isDisabled = true
              for (var c = 0; c < this.filtersDataUpdated[i].child[a].value.length; c++)
              {
                if (this.filtersDataUpdated[i].child[a].value[c] == this.filtersData[i].child[a].value[b].name)
                {
                  this.filtersData[i].child[a].value[b].$isDisabled = false
                }
              }
            }
          }
        }
      } else
      {
        for (let i = 0; i < this.filtersData.length; i++)
        {
          for (let a = 0; a < this.filtersData[i].child.length; a++)
          {
            for (let b = 0; b < this.filtersData[i].child[a].value.length; b++)
            {
              this.filtersData[i].child[a].value[b].$isDisabled = false
            }
          }
        }
      }
    },
    getLinks()
    {
      axios.get('https://owen.ru/upl_files/modules/device_filter/links_comp.js').then(response =>
      {
        this.links = JSON.parse(JSON.stringify(response.data))
      })
    },
    getLocation()
    {
      return window.location.hash !== '#frame'
    },
  },
  created()
  {
    this.getFilters()
    this.getTableData()
    this.getLinks()

    if (window.location.hash.split('/')[0] === '#iframe')
    {
      this.userHash = window.location.hash.split('/')[1]

      axios.get(process.env.NODE_ENV === 'production' ? '/upl_files/modules/select_backend/mailer/form.php' : 'http://selectbackend:8081/form.php', {
        params: {
          hash: this.userHash
        }
      }).then(response =>
      {
        if (response.data)
        {
          this.form.adress = response.data.adress
          this.form.companyName = response.data.companyName
          this.form.emails = JSON.parse(response.data.email)
          this.form.phones = response.data.phone.split(',')
          this.preview_logo = 'https://owen.ru/upl_files/modules/select_backend/mailer/uploads/' + response.data.logo
        }
      })
    } else {
      this.form.adress = '111024, Москва, 2-ая улица Энтузиастов, д. 5, корп. 5'
      this.form.companyName = 'ООО ОВЕН'
      this.form.emails = [
            {email: "sales@owen.ru", main:true, department: "отдел сбыта"},
            {email: "support@owen.ru", main:false, department: "тех. поддержка 24х7"},
          ]
      this.form.phones = ['(495) 641-11-56', '(495) 728-41-45', '800-775-63-83']
      this.preview_logo = 'https://owen.ru/upl_files/modules/select_backend/mailer/uploads/1637932782logo_valid.jpg'
    }
  },
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

.mail {
  cursor: pointer;
  background: #008f86;
  display: flex;
  padding: 5px 10px;
  margin-bottom: 5px;
  border-radius: 3px;
}

#select_modification {
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Roboto', sans-serif;
  min-height: 800px;
  font-size: 12px;
  line-height: 1.6;
  color: #333;
}


* {
  box-sizing: border-box;
}

.product-card__button {
  background: #008f86;
  position: relative;
  border-radius: 3px;
  text-transform: uppercase;
  padding: 4px 10px;
  display: inline-block;
  font-weight: 300;
  font-size: 11px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff !important;
  text-decoration: none !important;
  margin-bottom: 5px;
}

.secondary {
  border: solid 1px #008f86;
  background: #fff;
  color: #008f86 !important;
  margin-left: 10px;
}

.secondary:hover {
  border: 1px solid #9f0412;
  background: #9f0412;
  color: #fff !important;

}

.secondary:hover svg {
  fill: #fff !important;
}

</style>

<style scoped>
.buttons a {
  font-size: 14px;
}

#select_modification {
  position: relative;
}

.controll-container {
  padding: 15px 0;
}

.controll-container, .buttons {
  display: flex;
  align-items: center;
}

.products-count {
  flex: 1;
}

.buttons a {
  margin-left: 10px;
}


.df-button {
  cursor: pointer;
  position: relative;
  display: inline-block;
  border-width: 0;
  outline-width: 0;
  padding: 11px 23px;
  text-transform: uppercase;
  border-radius: 3px;
  max-width: 275px;
  background: #008f86;
  color: #fff;
  font-size: 1em;
  font-weight: 400;
  -webkit-transition: background .2s;
  -moz-transition: background .2s;
  -o-transition: background .2s;
  -ms-transition: background .2s;
  transition: background .2s;
}

.df-button:hover {
  background: #9f0412
}

.df-button:active {
  top: 1px;
  left: 1px
}

@media screen and (max-width: 550px) {
  .controll-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .buttons {
    flex-direction: column;
    align-items: flex-start;
  }

  .buttons a {
    margin-left: 0;
  }
}


</style>
